// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1IKRz","col":"styles_col__Hjg96"};